import ownerAPI from "../services/ownerApi";
import { redirectToClinicPortal } from "./portalHost";
import { getPortalByRole } from "./portalTypes";

/** Вход в админку клуба из кабинета владельца без повторного логина. */
export async function openOwnerClubPortal(club) {
  const tenantId = club?.id;
  const subdomain = String(club?.subdomain || "").trim().toLowerCase();
  if (!tenantId || !subdomain) return;

  const path = getPortalByRole("owner").app;
  try {
    const data = await ownerAPI.enterClubPortal(tenantId);
    redirectToClinicPortal(subdomain, path, data?.accessToken);
  } catch {
    redirectToClinicPortal(subdomain, path);
  }
}
